import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	[
		'assignedWorkTitle',
		'activeTeamTitle',
		'assignedWorkBody',
		'activeTeamBody',
		'assignedWorkCta',
		'activeTeamCta',
		'whyTitle',
		'whyBody',
	]
> = defineContent({
	default: {
		assignedWorkTitle: {
			id: 'c2j-confluence-side-nav.assigned-work.title',
			defaultMessage:
				'{itemCount, plural, one {# work item needs you} other {# work items need you}}',
			description:
				'Title shown to an inactive Jira user with assigned work. itemCount is the number of Jira work items assigned to them.',
			role: 'title',
		},
		activeTeamTitle: {
			id: 'c2j-confluence-side-nav.active-team.title',
			defaultMessage: 'Your team is in {teamSpaceName} space',
			description:
				'Title shown when Confluence collaborators are active in Jira. teamSpaceName is the name of the Jira space they work in.',
		},
		assignedWorkBody: {
			id: 'c2j-confluence-side-nav.assigned-work.body',
			defaultMessage:
				'{collaboratorCount, plural, =0 {Your teammates are moving them in Jira} one {{collaboratorNames} is moving them in Jira} other {{collaboratorNames} are moving them in Jira}}',
			description:
				'Description of the assigned Jira work recommendation. collaboratorNames is a formatted list of up to 3 teammate names; collaboratorCount is how many are listed.',
			role: 'description',
		},
		activeTeamBody: {
			id: 'c2j-confluence-side-nav.active-team.body',
			defaultMessage: '{itemCount, plural, one {# item} other {# items}} moved this week',
			description:
				'Description of the active Jira team recommendation. itemCount is the number of Jira work items the team moved this week.',
		},
		assignedWorkCta: {
			id: 'c2j-confluence-side-nav.assigned-work.cta',
			defaultMessage: 'Review',
			description: 'CTA for viewing assigned work in Jira',
		},
		activeTeamCta: {
			id: 'c2j-confluence-side-nav.active-team.cta',
			defaultMessage: 'Join them',
			description: 'CTA for opening the Jira project used by teammates',
		},
		whyTitle: {
			id: 'c2j-confluence-side-nav.why.title',
			defaultMessage: 'Why am I seeing this?',
			description: 'Title of the recommendation explanation',
		},
		whyBody: {
			id: 'c2j-confluence-side-nav.why.body',
			defaultMessage: 'This recommendation is based on Jira work relevant to you and your team.',
			description: 'Explanation of why the Jira recommendation is shown',
		},
	},
});
